import { PHONEME_TYPE } from './constant.js';
import { phonemeElementToHtml } from './element-to-html.js';
import { phonemeHtmlToElement } from './html-to-element.js';
import { phonemePlugin } from './plugin.js';
import { phonemeRenderElement } from './render-element.js';
import { phonemeSerializer } from './serializer.js';

const PhonemeModule = {
  type: PHONEME_TYPE,
  renderElement: phonemeRenderElement,
  elementToHtml: phonemeElementToHtml,
  htmlToElement: phonemeHtmlToElement,
  plugin: phonemePlugin,
  serializer: phonemeSerializer
};

export { PhonemeModule };
//# sourceMappingURL=module.js.map
